import { render, staticRenderFns } from "./InventoryQuotas.vue?vue&type=template&id=58f10fdc&scoped=true"
import script from "./InventoryQuotas.vue?vue&type=script&lang=js"
export * from "./InventoryQuotas.vue?vue&type=script&lang=js"
import style0 from "./InventoryQuotas.vue?vue&type=style&index=0&id=58f10fdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f10fdc",
  null
  
)

export default component.exports